<app-top-header
  class="top-bar-container"
  bgStyle="solid"
  screenTitle="Login"
></app-top-header>
<div class="page-content px-4 my-4">
  <app-login-part [returnTo]="redirectTo"></app-login-part>
</div>
<!-- <app-footer></app-footer> -->
